const radixParameter = {
  DEFAULT: 10,
};

export default radixParameter;
